import template from './gauge-progress-bar.html';
import controller from './gauge-progress-bar.controller';

let GaugeProgressBarComponent = {
    restrict: 'E',
    bindings: {
        current: '<',      // Current value
        total: '<',         // Total/target value
        size: '@',         // Size of the gauge (default: 200)
        strokeWidth: '@',  // Stroke width (default: 20)
        color: '@',        // Progress color (default: #27ae60)
        bgColor: '@',      // Background color (default: #e0e0e0)
        minValue: '<',     // Minimum value (default: 0)
        maxValue: '<',     // Maximum value (default: total)
        showPercentage: '<', // Show percentage text (default: true)
        showValue: '<',     // Show current value (default: true)
        showLabel: '<',     // Show label text (default: false)
        label: '@',        // Label text to display
        gaugeType: '@'     // 'semicircle' or 'circle' (default: 'semicircle')
    },
    template,
    controller
}

export default GaugeProgressBarComponent;




// WEBPACK FOOTER //
// ./client/common/directives/gauge-progress-bar/gauge-progress-bar.component.js